import React ,{useRef} from 'react'
// import { useState } from 'react'
import "./Contact.css";
import bgTabOne from "../../asset/info.png"; // Image for Tab One
import emailjs from '@emailjs/browser';


const Contact = () => {
    const form = useRef();
    const sendEmail = (e) => {
        e.preventDefault();
    
        emailjs
          .sendForm('service_7sm9p5m', 'template_zy7eka5', form.current, {
            publicKey: 'Hzl05hDOtUlsxbJ0y',
          })
          .then(
            () => {
                alert('Message sent successfully')
                e.target.reset()
              console.log('SUCCESS!');
            },
            (error) => {
              console.log('FAILED...', error.text);
            },
          );
      };
    
  return (
    <section id="contactPage">
        <div id="contact">
            <h1 className="contactPageTitle">Contact Me</h1>
            <span className="contactDesc">Lorem, ipsum dolor sit amet consectetur adipisicing elit. Mollitia, possimus!</span>
            <form id="contactForm" ref={form} onSubmit={sendEmail}>
                <input type="text" className='name' placeholder='Your Name' name='your_name'/>
                <input type="email" className='email' placeholder='Your Email' name='your_email'/>
                <textarea name="message" className="msg" rows="5" placeholder='Your Message'></textarea> <br />
<button className="submitBtn" type="submit">Submit</button>
            
            </form>
        </div>
    </section>
  )
}

export default Contact